module.exports = __webpack_public_path__ + "static/media/Teuko kids lunchbox ideas community landing features Feed _compressed.cebb554e.mp4";